import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SqlMICopySource } from 'app/model/pipeline/copysource/sql-mi.copysource';
import { SqlCopySourceAdapter, sqlSourceAdapts } from './sql.copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlMICopySource),
    asynchronous: true,
    adapts: sqlSourceAdapts
})
export class SqlMICopySourceAdapter extends SqlCopySourceAdapter {}
